import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import { environment } from '../../environments/environment';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let obj =this;
    const domain = window.location.hostname;
    let subDomain = "";
    if (domain.indexOf('.') < 0 ||
      domain.split('.')[0] === 'login' || domain.split('.')[0] === 'liveadmin' || domain.split('.')[0] === 'v3' || domain.split('.')[0] === '192' || domain.split('.')[0] === 'admin' || domain.split('.')[0] === 'www' || domain.split('.')[0] === 'beta' || domain.split('.')[0] === 'staging') {
      subDomain = '';
      if (localStorage.getItem("userToken") != null) {
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));
        if (userDetails) {
          if (route.data.roles && route.data.roles.indexOf(userDetails.type) === -1) {
            // role not authorised so redirect to home page
            this.router.navigate(["/login"]);
            return false;
          }
          if (localStorage.getItem('isorder') == 'yes') {
            // if (confirm("You have unsaved changes! If you leave, your changes will be lost.")) {
              // obj.router.navigate(["/dashboard"]);
              localStorage.removeItem('isorder');
              return true;
            // } else {
            //   return false;
            // }
          }

          return true;
        }
        //return true;
      }
      this.router.navigate(["/login"]);
      return false;
    }
    else {
      subDomain = domain.split('.')[0];
      let urlParts = domain.split('.');
      let baseDomain = urlParts.slice(0).slice(-(urlParts.length === 4 ? 3 : 2)).join('.');
      baseDomain == environment.PublicQuoteBuilder_URL ? this.router.navigate(['/builder']) : this.router.navigate(['/store']);  
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_guards/auth.guard.ts